// @flow
import React from 'react';

import { SECTION } from 'Client/cms/toolkit/constants';
import { Line } from 'Components/frameworks/line/Line.jsx';

export const sectionDescriptor = {
  name: SECTION,
  component: (props: *) => <Line props={props} />,
};
